import {
  BooleanField,
  Datagrid,
  DateField,
  List,
  TextField,
} from "react-admin";

export function InAppAdsList(props) {
  return (
    <List {...props}>
      <Datagrid rowClick="show">
        <TextField source="title" />
        <BooleanField source="isActive" />
        <DateField source="createdDate" showTime />
        <DateField source="updatedDate" showTime />
      </Datagrid>
    </List>
  );
}
